import ApiService from '@/services/ApiService'

const REPOSITORY_URL = 'usuario'

const AccesoRepository = {
  listaAcceso () {
    return ApiService.get(`${REPOSITORY_URL}/lista_acceso`)
  },

  esAdmin () {
    return ApiService.get(`${REPOSITORY_URL}/es_admin`)
  },
}

export default AccesoRepository
